<header class="banner">
  <ng-container *ngIf="isLogoClickable; else nonClickableLogo">
    <a href="javascript:void(0)" (click)="goToHome()" class="logo-link" aria-label="Go to Inspera Originality home">
      <img class="logo" src="../../../../../../assets/report_v2/inspera_originality.svg" alt="Inspera Originality logo">
    </a>
  </ng-container>
  <ng-template #nonClickableLogo>
    <div class="logo-link">
      <img class="logo" src="../../../../../../assets/report_v2/inspera_originality.svg" alt="Inspera Originality logo">
    </div>
  </ng-template>
  <section>
    <div (click)="toggleMenuBar('submissionDetails')" tabindex="-1" data-menu-bar-key="submissionDetails"
      class="banner_options_option submission_details" [class.menu-open]="activeMenuBar['submissionDetails']"
      appCloseMenu>
      <button class="d-flex inside-btn" tabindex="0" aria-label="Document Information" title="View Submission details"
        aria-haspopup="dialog">
        <img src="../../../../../../assets/report_v2/submission_details.svg" alt="document">
        <p class="fontColor">{{ 'new_entries.details' | translate }}</p>
      </button>
      <div class="dropdown menubar article" role="dialog" aria-label="Submission Details Panel" cdkTrapFocus>
        <div class="menubar-head" aria-label="Submission Details Header">
          <h2 aria-label="Submission details title">{{ 'new_entries.submission_details' | translate }}</h2>
          <button aria-label="Close" class="close-menubar" (click)="closeMenuBar('submissionDetails', $event)">
            <img src="../../../../../../assets/report_v2/close_big.svg" alt="">
          </button>
        </div>
        <div class="menubar-body" role="presentation">
          <section [attr.aria-label]="'Document title is. ' + bannerDetails.title">
            <h3>{{ 'general.table.name' | translate }}</h3>
            <p>{{ bannerDetails.title }}</p>
          </section>
          <section [attr.aria-label]="'Document ID is. ' + bannerDetails.documentId">
            <h3>{{ 'general.table.document_id' | translate }}</h3>
            <p>{{ bannerDetails.documentId }}</p>
          </section>
          <section [attr.aria-label]="'Document Language is. ' + getLanguageName(bannerDetails.original_language)"
            aria-live="polite">
            <h3>{{ 'report.document_language' | translate }}</h3>
            <p>{{ getLanguageName(bannerDetails.original_language) }}</p>
          </section>
          <section *ngIf="bannerDetails.translated_language && bannerDetails.translated_language.length !== 2"
            [attr.aria-label]="'Translated Language is. ' + getLanguageName(bannerDetails.translated_language)"
            aria-live="polite">
            <h3>{{ 'app.upload.translated_language' | translate }}</h3>
            <p>{{ getLanguageName(bannerDetails.translated_language) }}</p>
          </section>
          <section
            [attr.aria-label]="'AI authorship analysis is. ' + (bannerDetails.ai_authorship_analysis ? 'On' : 'Off')"
            aria-live="polite">
            <h3>{{ 'new_entries.ai_authorship_analysis' | translate }}</h3>
            <ng-container *ngIf="bannerDetails.ai_authorship_analysis; else off">
              <p>{{ 'new_entries.on' | translate }}</p>
            </ng-container>
            <ng-template #off>
              <p>{{ 'new_entries.off' | translate }}</p>
            </ng-template>

            <!-- <p *ngIf="bannerDetails.ai_authorship_analysis; else off">On</p>
              <p #off>Off</p> -->
          </section>
          <section [attr.aria-label]="'File size is. ' + (bannerDetails.file_size || '1.20 MB')" aria-live="polite">
            <h3>{{ 'new_entries.file_size' | translate }}</h3>
            <p>{{ bannerDetails.file_size || '1.20 MB' }}</p>
          </section>
          <section [attr.aria-label]="'Word count is. ' + bannerDetails.word_count" aria-live="polite">
            <h3>{{ 'new_entries.word_count' | translate }}</h3>
            <p>{{ bannerDetails.word_count }}</p>
          </section>
          <section [attr.aria-label]="'Page count is. ' + bannerDetails.page_count" aria-live="polite">
            <h3>{{ 'new_entries.page_count' | translate }}</h3>
            <p>{{ bannerDetails.page_count }}</p>
          </section>
        </div>
      </div>
    </div>
    <div data-menu-bar-key="download" class="banner_options_option" (click)="toggleMenuBar('download')"
      [class.menu-open]="activeMenuBar['download']" appCloseMenu>
      <button aria-label="Downloads" class="inside-btn" [attr.aria-expanded]="activeMenuBar['download']"
        aria-controls="download-menu" title="View documents available for download">
        <img src="../../../../../../assets/report_v2/download.svg" alt="Downloads">
        <p class="fontColor">{{ 'general.download' | translate }}</p>
      </button>
      <section id="download-menu" role="menu" class="dropdown" [attr.aria-hidden]="!activeMenuBar['download']"
        *ngIf="activeMenuBar['download']" cdkTrapFocus>
        <button role="menuitem" tabindex="0" aria-label="Download Offline Report"
          (click)="downloadPdfReport('crossplag')" (keydown.escape)="closeMenuBar('download', $event)">
          <p>{{ 'report.offline_report' | translate }}</p>
        </button>
        <button role="menuitem" tabindex="0" aria-label="Download Document File" (click)="downloadOriginalDocument()"
          (keydown.escape)="closeMenuBar('download', $event)">
          <p>{{ 'general.document_file' | translate }}</p>
        </button>
      </section>
    </div>
    <button tabindex="0" class="banner_options_option" (click)="openSettingsModal()" aria-label="Settings"
      aria-haspopup="dialog">
      <img src="../../../../../../assets/report_v2/settings.svg" alt="Settings">
      <p class="fontColor">{{ 'aria-labels.settings' | translate }}</p>
    </button>
    <button *ngIf="showExpandView" tabindex="0" (click)="openLink(newTab)" class="banner_options_option">
      <img src="../../../../../../assets/report_v2/open_in_another_tab.svg"
        alt="Open in another tab. Click in order to open the report in another tab.">
      <p class="fontColor" aria-label="Open in another tab name">{{ 'general.expand' | translate }}</p>
    </button>
    <button tabindex="0" role="link"
      (click)="openLink('https://support.inspera.com/hc/en-us/categories/15848147005085-Inspera-Originality')"
      class="banner_options_option">
      <img src="../../../../../../assets/report_v2/help-circle.svg" alt="Help Center">
      <p class="fontColor" aria-label="Help Center.">{{ 'general.help' | translate }}</p>
    </button>
  </section>
</header>